var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-d334fd3e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "body" };
var _hoisted_2 = { class: "flex overflow-hidden items-stretch max-w-full body lg:rounded-lg shadow-custom relative" };
import School from './components/School/School.vue';
import ContentSide from './components/ContentSide/ContentSide.vue';
import { planFeatures } from '@common/utils/Plans';
import Auth, { AuthEvents } from '@common/modules/auth';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { ChatStore, CoreStore, LightboxStore } from '@common/stores';
import { useEventBus } from '@vueuse/core';
import EResizer from '@common/ui/EResizer/EResizer.vue';
import { isMobile, isTouchable } from '@common/utils/Crossbrowser';
import { useChatWebsocket } from '@common/api/ws/hooks/useChatWebsocket';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Messages',
    setup: function (__props) {
        var _this = this;
        var hidden = computed(function () { return ChatStore.hidden; });
        var mainSection = computed(function () { return ChatStore.mainSection; });
        var isResizerDisabled = computed(function () { return isMobile() || isTouchable(); });
        var coreStore = CoreStore;
        var busSocket = useEventBus('websocketMessage');
        var busSignIn = useEventBus(AuthEvents.AUTH_SIGNED_IN);
        var busSignOut = useEventBus(AuthEvents.AUTH_SIGNED_OUT);
        var chatWidth = ref(290);
        var onChatWidthChange = function (newWidth) {
            chatWidth.value = newWidth;
        };
        useChatWebsocket(function (payload) {
            onMessage(payload.action, payload);
        });
        var init = function () {
            if (Auth.isGuest() || !coreStore.canUseFeature(planFeatures.CHAT_FEATURE_CODE))
                return;
            ChatStore.getChats();
            // watch on key 'esc'
            document.body.addEventListener('keyup', onKeyup);
        };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                init();
                // // Включаем чат если авторизация изменилась
                busSignIn.on(init);
                // // Включаем отключаем если авторизация изменилась
                busSignOut.on(function () {
                    busSocket.off();
                });
                return [2 /*return*/];
            });
        }); });
        onBeforeUnmount(function () {
            // unwatch on key 'esc'
            document.body.removeEventListener('keyup', onKeyup);
        });
        var onMessage = function (event, data) {
            if (event === 'messageSend') {
                ChatStore.appendMessage(data.chatId, data.message);
            }
            if (event === 'messageEdit') {
                ChatStore.updateEditedMessage(data.chatId, data.message);
            }
            if (event === 'messageDelete') {
                ChatStore.updateDeletedMessages(data.chatId, data.chatLastMessage, data.messages);
            }
        };
        var close = function () {
            ChatStore.hide();
        };
        var onEscape = function () {
            // Если отображается лайтбокс, то не закрываем сообщения
            if (!LightboxStore.singleLightboxHidden) {
                return;
            }
            close();
        };
        var onKeyup = function (e) {
            if (hidden.value)
                return;
            if (e.key === 'Escape') {
                onEscape();
            }
        };
        return function (_ctx, _cache) {
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                "append-to-body": false,
                visible: !hidden.value,
                class: "modal modal-select-type",
                name: "messages",
                size: "fitContent",
                "no-padding": "",
                onClose: close
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (isResizerDisabled.value)
                                ? (_openBlock(), _createBlock(School, {
                                    key: 0,
                                    class: _normalizeClass([{
                                            'section--hidden': mainSection.value !== 'list',
                                        }, "section section--school"])
                                }, null, 8, ["class"]))
                                : (_openBlock(), _createBlock(EResizer, {
                                    key: 1,
                                    "max-width": 390,
                                    "min-width": 290,
                                    "resize-by": ['right'],
                                    width: chatWidth.value,
                                    class: "shrink-0 max-w-[60%]",
                                    "divider-size": "medium",
                                    "is-divider-external": "",
                                    "is-divider-full": "",
                                    "is-divider-transparent": "",
                                    onChangeWidth: onChatWidthChange
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(School, {
                                            class: _normalizeClass([{
                                                    'section--hidden': (mainSection.value !== 'list' && isResizerDisabled.value),
                                                }, "section section--school"])
                                        }, null, 8, ["class"])
                                    ]; }),
                                    _: 1
                                }, 8, ["width"])),
                            _createVNode(ContentSide, {
                                class: _normalizeClass([{
                                        'section--hidden': (mainSection.value !== 'content' && isResizerDisabled.value),
                                    }, "section"])
                            }, null, 8, ["class"])
                        ])
                    ])
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
